import client from '@/lib/axios-client'
import type {
	ChangePasswordRequest,
	ForceChangePasswordRequest,
	LoginRequest,
	LoginResponse,
	RefreshRequest,
	RefreshResponse,
	UserProfile,
} from '@/types/auth'

const AUTH_URL = '/auth'

export async function login(data: LoginRequest): Promise<LoginResponse> {
	const response = await client.post(`${AUTH_URL}/login`, data)
	return response.data.data
}

export async function refreshTokens(
	data: RefreshRequest,
): Promise<RefreshResponse> {
	const response = await client.post(`${AUTH_URL}/refresh`, data)
	return response.data.data
}

export async function logout(data: RefreshRequest): Promise<void> {
	await client.post(`${AUTH_URL}/logout`, data)
}

export async function getMe(): Promise<UserProfile> {
	const response = await client.get(`${AUTH_URL}/me`)
	return response.data.data
}

export async function forceChangePassword(
	data: ForceChangePasswordRequest,
): Promise<void> {
	await client.post(`${AUTH_URL}/force-change-password`, data)
}

export async function changePassword(
	data: ChangePasswordRequest,
): Promise<void> {
	await client.post(`${AUTH_URL}/change-password`, data)
}
